// FrameComponent.js
import { useState } from "react";
import FrameComponent1 from "./FrameComponent1";
import "./FrameComponent.css";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Swal from "sweetalert2";
import axios from "axios";

const FrameComponent = () => {
  const [formData, setFormData] = useState({
    displayName: "",
    UserName: "",
    email: "",
    password: "",
    role: "subscriber",
  });
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    if (
      formData.displayName === "" ||
      formData.UserName === "" ||
      formData.password === "" ||
      formData.email === ""
    ) {
      Swal.fire({
        icon: "error",
        title: "Fill in all required fields",
        text: "Fail to sign up to your account.",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "OK",
      });
      return;
    }
    try {
      const response = await axios.post(
        "http://127.0.0.1:8000/user/create-user",
        formData
      );
      if (response.status === 200) {
        navigate("/");
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to send credentials",
          text: "Fail to sign up to your account.",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Email already exists",
        text: "Fail to sign up to your account.",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <form className="frame-form" onSubmit={handleSubmit}>
      <div className="frame-parent2">
        <div className="frame-parent1">
          <div className="username-or-email-address-parent">
            <div className="username-or-email7">Name</div>
            <input
              className="email-input2"
              type="text"
              name="displayName"
              value={formData.displayName}
              onChange={handleInputChange}
            />
          </div>
          <div className="username-or-email-address-group">
            <div className="password4">User Name</div>
            <input
              className="email-input3"
              type="text"
              name="UserName"
              value={formData.UserName}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="frame-parent1">
          <div className="username-or-email-address-parent">
            <div className="username-or-email7">Email</div>
            <input
              className="email-input2"
              type="text"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>
          <div className="username-or-email-address-group">
            <div className="password4">Password</div>
            <input
              className="email-input3"
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleInputChange}
            />
            {showPassword ? (
              <VisibilityOffIcon
                className="toggle-password-icon"
                onClick={handleTogglePasswordVisibility}
              />
            ) : (
              <VisibilityIcon
                className="toggle-password-icon"
                onClick={handleTogglePasswordVisibility}
              />
            )}
          </div>
        </div>
      </div>
      <button type="submit" className="sign-in-container">
        <div className="sign-in5">Sign up</div>
      </button>
      <footer className="frame-footer">
        <div className="dont-have-an-container1">
          <span>{`Already have an account? `}</span>
          <span className="click-here-to1">
            <a href="/signin">Click here to sign in.</a>
          </span>
        </div>
      </footer>
    </form>
  );
};

export default FrameComponent;
